//@flow
import {useEffect} from 'react';
import {useSelector} from 'react-redux';
import {useActions} from '../../../utils/globalStore';
import {actions} from '../../products/duck';

import type {RootState} from '../../';
import type {ProductVariantOption} from '../../../entities';

const productVariantOptionsSelector = (state: RootState) =>
  state.products.globalProductVariantOptions;

export function useInitializeProductVariant():
  | ProductVariantOption[]
  | undefined {
  const fetchProductVariantOptions = useActions(
    actions.fetchProductVariantOptions
  );

  const productVariantOptions = useSelector(productVariantOptionsSelector);

  useEffect(() => {
    if (productVariantOptions) return;
    fetchProductVariantOptions();
  }, [fetchProductVariantOptions, productVariantOptions]);

  return productVariantOptions;
}

export function useProductVariants(): ProductVariantOption[] | undefined {
  const productVariantOptions = useInitializeProductVariant();

  return productVariantOptions;
}
